/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureMcaBillingProfile extends models.ServiceAccountNativeDetailsBaseForStructure {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureMcaBillingProfile");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureMcaBillingProfile.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureMcaBillingProfile>): ServiceAccountNativeDetailsForAzureMcaBillingProfile {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureMcaBillingProfile(), model);
        ServiceAccountNativeDetailsForAzureMcaBillingProfile.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureMcaBillingProfile>): ServiceAccountNativeDetailsForAzureMcaBillingProfile {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureMcaBillingProfile.newInstance(<ServiceAccountNativeDetailsForAzureMcaBillingProfile> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureMcaBillingProfile) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureMcaBillingProfile.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureMcaBillingProfile): boolean {
        if (models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureMcaBillingProfile.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing Profile Id
     */
    billing_profile_id: string;

    /**
     * Billing Profile Name
     */
    billing_profile_name: string;

}
